import { useEffect, useState } from 'react';

import { useGatedBySlug } from '~/hooks/useGatedBySlug';
import { SectionData } from '~/lib/contentful/custom-types';
import { Section } from '~/old-marketing/components/sections/Section';
import { sectionRenderer } from '~/old-marketing/utils/sectionRenderer';

const TEMPLATE_KEY = 'gated-by-slug';

export type GatedBySlugSectionTemplateProps = Pick<SectionData, 'id' | 'subsections'>;

export const GatedBySlugSectionTemplate = ({ id, subsections }: GatedBySlugSectionTemplateProps) => {
  const [isGatedBySlug] = useGatedBySlug();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);

    return () => setIsMounted(false);
  }, []);

  if (!isMounted || isGatedBySlug) return null;

  return (
    <Section id={id} templateKey={TEMPLATE_KEY} css={{ overflow: 'visible' }}>
      {subsections?.map((subsection, index) => sectionRenderer(subsection, index, true))}
    </Section>
  );
};

GatedBySlugSectionTemplate.templateKey = TEMPLATE_KEY;
